import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../../shared/Carousel';
import {getSafeTranslations} from '../../../utils/hitLabels';
import DestinationCard from '../Cards/DestinationCard';
import {CAROUSEL_TYPES} from '../../../utils/edap/edapEventsConstants';
import {get} from '../../../utils/helpers';

function DestinationCarousel(props) {
    const {
        aspectRatio,
        breakpoints,
        cardLinkTarget,
        cardSizeSm,
        clientRequestId,
        customCardClickHandler,
        isMobile,
        layoutAlignment,
        onCardsShownChange,
        propertyViewEventFirePosition,
        scrolling,
        scrollMarginOffset,
        subtitle,
        target,
        title,
    } = props;
    const {nextButtonLabel, prevButtonLabel} = getSafeTranslations();

    const getDestinationCards = (recommendedHits = []) => {
        const validHits = recommendedHits.filter((hit) => {
            const {imageHref, place} = hit;
            return imageHref && get(place, 'name.simple');
        });

        return validHits.reduce((filteredHits, cardProps, position) => {
            filteredHits.push(
                <DestinationCard
                    {...cardProps}
                    aspectRatio={aspectRatio}
                    cardIndex={position + 1}
                    clientRequestId={clientRequestId}
                    target={target}
                    cardLinkTarget={cardLinkTarget}
                    key={`destinations-${position}`}
                    customCardClickHandler={customCardClickHandler}
                />
            );
            return filteredHits;
        }, []);
    };

    const cards = getDestinationCards(props.data);

    return (
        <Carousel
            carouselType={CAROUSEL_TYPES.DESTINATION}
            cards={cards}
            hits={props.data}
            subheading={subtitle}
            translations={{
                nextButtonLabel,
                prevButtonLabel,
            }}
            {...{
                breakpoints,
                title,
                cards,
                cardSizeSm,
                clientRequestId,
                isMobile,
                layoutAlignment,
                onCardsShownChange,
                propertyViewEventFirePosition,
                scrolling,
                scrollMarginOffset,
            }}
        />
    );
}

DestinationCarousel.propTypes = {
    aspectRatio: PropTypes.string,
    breakpoints: PropTypes.objectOf(PropTypes.number),
    className: PropTypes.string,
    cardLinkTarget: PropTypes.string,
    cardSizeSm: PropTypes.bool,
    customCardClickHandler: PropTypes.func,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    layoutAlignment: PropTypes.oneOf([
        'container',
        'cards',
        'cardsWithOverlapButtons',
        'buttons',
    ]),
    propertyViewEventFirePosition: PropTypes.oneOf(['top', 'bottom', 'onload']),
    onCardsShownChange: PropTypes.func,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            destinationUrl: PropTypes.string,
            imageHref: PropTypes.string,
            searchTermUuid: PropTypes.string,
            place: PropTypes.shape({
                name: PropTypes.shape({
                    simple: PropTypes.string,
                    full: PropTypes.string,
                }),
            }),
        })
    ),
    scrolling: PropTypes.bool,
    scrollMarginOffset: PropTypes.number,
    subheading: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default DestinationCarousel;
